const FOOTER_LINKS = {
  '热门分类': ['动作大片', '喜剧之王', '悬疑烧脑', '科幻巨制', '武侠江湖', '爱情经典'],
  '资源平台': ['飘花电影网', '555电影', '8090电影网', '高清影视', '最新电影'],
  '关于我们': ['平台介绍', '常见问题', '联系我们', '用户反馈', '加入我们'],
};

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-200/80 border-t border-background-300/40">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-50 font-heading whitespace-nowrap">
                麻花影视
              </span>
            </a>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed max-w-xs">
              聚合飘花电影网、555电影、8090电影网等高清影视资源，提供最新电影、电视剧、综艺节目免费在线观看。片库全、更新快、不缓冲，让每一位影迷都能享受极致的观影体验。
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4 whitespace-nowrap">
                {category}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#index"
                      onClick={(e) => { e.preventDefault(); scrollTo('index'); }}
                      className="text-xs md:text-sm text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/30">
          <div className="text-center mb-6">
            <h3 className="text-sm font-semibold text-foreground-300 mb-3">
              合作伙伴
            </h3>
            <p className="text-xs text-foreground-600">
              感谢以下平台与麻花影视携手共建优质影视生态
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6 mt-4">
              <span className="text-xs text-foreground-600 px-3 py-1.5 rounded-lg bg-background-300/30">飘花电影网</span>
              <span className="text-xs text-foreground-600 px-3 py-1.5 rounded-lg bg-background-300/30">555电影</span>
              <span className="text-xs text-foreground-600 px-3 py-1.5 rounded-lg bg-background-300/30">8090电影网</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600 text-center sm:text-left">
              &copy; 2026 麻花影视 - 电影大全高清影视免费在线观看。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">回到顶部</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('faq'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">帮助中心</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}